import DemoPage from "./demo.jsx";

export default function DemoEn() {
  return <DemoPage forcedLang="en" />;
}